<template>
  <div id="app">
  	<div v-if="!$auth.ready()">
  		... Loading
  	</div>
  	<div v-if="$auth.ready()">
  		<vue-full-loading	v-bind:event-bus="loader"
  							event-show="startLoadingAnimation"
  							event-hide="stopLoadingAnimation"
  							label="Lädt"></vue-full-loading>
	    <router-view/>
  	</div>
  </div>
</template>

<script>
// Organize imports
import VueFullLoading from 'vue-full-loading';
import { Loader } from './bus/loader.js';

export default {
	data: function() {
		return {
		};
	},
	computed: {
		loader: function() {
			return Loader;
		},
	},
	components: {
		'vue-full-loading': VueFullLoading,
	}
}
</script>

<style>
/* Import entypo icon font */
/* @import url(http://weloveiconfonts.com/api/?family=entypo);
[class*="entypo-"]:before {
  font-family: 'entypo', sans-serif;
}
*/

#app {
	font-family: 'Source Sans Pro', sans-serif;
	color: #2c3e50;
	font-size: 18px;
}
.no-padding {
	padding: 0 !important;
}
.has-error {
	border: 1px solid #ff0000;
	border-radius: 0.25rem;
}
.error-message {
	color: #ff0000;
	font-size: 0.95rem;
}

/* Space styles */
.space10 {
	height: 10px;
	line-height: 10px;
}
.space20 {
	height: 20px;
	line-height: 20px;
}
.space30 {
	height: 30px;
	line-height: 30px;
}
.space40 {
	height: 40px;
	line-height: 40px;
}
.space50 {
	height: 50px;
	line-height: 50px;
}
.space55 {
	height: 55px;
	line-height: 55px;
}
.space60 {
	height: 60px;
	line-height: 60px;
}

/* Tile styles */
.tile-container {
	/* background-color: #f2f2f2; */
	background-color: #f9fafb;
	padding: 20px;
	height: 100%;
}
.tile-content {
	background-color: #ffffff;
	padding: 2rem;
	height: 100%;
	border: 1px solid rgba(0,0,0,.0625);	
}

/* Specific VRNU styles */
button {
}
.vrnu-link {
	color: #FF6600 !important;
}
.vrnu-link:hover {
	color: #FF6600 !important;
}
.vrnu-button-full {
	background-color: #FF6600 !important;
	border-color: #FF6600 !important;
	width: 100% !important;
}
.vrnu-button-full:HOVER {
	background-color: #ff944d !important;
	border-color: #ff944d !important;
	width: 100% !important;
}
.vrnu-button {
	background-color: #FF6600 !important;
	border-color: #FF6600 !important;
}
.vrnu-button:HOVER {
	background-color: #ff944d !important;
	border-color: #ff944d !important;
}
.vrnu-headline {
	display: inline-block;	
	padding-bottom: 10px;
	margin-bottom: 30px;
	border-bottom: 3px solid #FF6600;

	color: #FF6600;
	font-weight: bold;	
}
.vrnu-headline-small {
	display: inline-block;	
	border-bottom: 3px solid #ffffff;
	padding-bottom: 6px;
	margin-bottom: 12px;

	color: #ffffff;
	font-weight: bold;	
	font-size: 1.4rem;
}
.text-underlined {
  /* display: inline-block; */
  padding-bottom: 10px;
  /* margin-bottom: 20px; */
  /* border-bottom: 2px solid; */

  /* font-weight: bold; */
}
.modal-content {
	border-radius: 0 !important;
}
.modal-header {
	background-color: #343a40 !important;
	color: rgba(255, 255, 255, 0.5) !important;
	border-radius: 0 !important;
}
.close {
	color: #ffffff !important;
}
.close:HOVER {
	color: #ffffff !important;
}
.button-right {
	float: right !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue